module.exports = __webpack_public_path__ + "static/media/ph.e761ff72.svg";